<ds-modal
  [id]="agentSelectionModalId"
  [closeOthers]="true"
  [maxWidth]="modalWidth"
  (onCloseModalEvent)="close()"
>
  <p dsContent [contentPath]="'policy.agentSelectHeader'"></p>
  <div>
    <form [formGroup]="agentNotificationForm">
      <ds-form-control-container
        [labelText]="'Select which agent'"
        [control]="agentNotificationForm.get('selectAgent')"
      >
        <select
          id="selectAgent"
          class="icon fill"
          formControlName="selectAgent"
          data-cy="selectAgent"
        >
          <option value=""></option>
          @for (agent of agents; track agent) {
            <option [value]="agent.agentId" data-cy="fullAgentName">{{ agent.fullName }}</option>
          }
        </select>
        <span class="icon-chevron-down"></span>
        <ds-form-control-message
          [control]="agentNotificationForm.get('selectAgent')"
        ></ds-form-control-message>
      </ds-form-control-container>
    </form>
  </div>
  <div class="pad-top-10">
    <button
      ds-button
      (click)="agentSelection()"
      class="fill"
      type="submit"
      [disabled]="!agentNotificationForm.valid"
      [attr.aria-label]="sendToAgentCopy"
    >
      {{ sendToAgentCopy }}
    </button>
  </div>
</ds-modal>
